module.exports = "mutation UpdateAttributeValue($attributeValue:UpdateAttributeValueInput!){updateAttributeValue(attributeValue:$attributeValue){success}}"